import React from 'react';
import { RiasecLastTestResponse, RiasecProfession } from '../../typings/riasec';
import RiasecLastTest from './RiasecLastTest';
import { Card } from "../UI/Card";
import Button from "../UI/Button";
import { Play } from "lucide-react";

interface RiasecTestIntroProps {
  loading: boolean;
  lastTest: RiasecLastTestResponse | null;
  professions: RiasecProfession[];
  onStartTest: () => void;
  onViewLastTestDetail: () => void;
}

const RiasecTestIntro: React.FC<RiasecTestIntroProps> = ({
  loading,
  lastTest,
  professions,
  onStartTest,
  onViewLastTestDetail
}) => {
  return (
    <div className="riasec-container p-3">
      <div className="w-full">
        <div className="flex flex-wrap">
          <div className="w-full">
            <h5 className="text-xl font-semibold mb-2 text-center">
              Interest Domain Explorer
            </h5>
            <Card className="p-4">
              <p className="text-gray-700 text-justify mb-3">
                Tes IDE (Interest Domain Explorer Test) membantu Anda menemukan
                minat karir berdasarkan 6 tipe kepribadian:{" "}
                <strong>Realistic</strong>, <strong>Investigative</strong>, <strong>Artistic</strong>, <strong>Social</strong>,
                <strong>Enterprising</strong>, dan <strong>Conventional</strong>.
              </p>
              <div className="p-4 rounded border bg-blue-50 border-blue-200 text-blue-800">
                <strong>Instruksi:</strong>
                <ul className="mb-0 mt-2 list-disc list-outside pl-4">
                  <li>Jawab semua pertanyaan dengan jujur</li>
                  <li>Pilih jawaban yang paling sesuai dengan minat Anda</li>
                  <li>Tidak ada jawaban yang benar atau salah</li>
                </ul>
              </div>
              <div className={"w-full flex justify-center mt-5"}>
                <Button
                  primary
                  block
                  className='gradient-primary text-lg font-semibold'
                  onClick={onStartTest}
                  disabled={loading}
                >
                  <Play /> {loading ? "Memuat..." : "Mulai Tes IDE"}
                </Button>
              </div>
            </Card>
            {lastTest && (
              <RiasecLastTest
                lastTest={lastTest}
                professions={professions}
                onViewDetail={onViewLastTestDetail}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiasecTestIntro;
